import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { deleteStatus, formUpdateStatus, updateFormInfo } from "../../redux/slice/formUpdateSlice";
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";
import { BANNER_API_PATH, RADIO_API_PATH } from "../../network/config/apiPaths";
import { updateMessage } from "../../redux/slice/toastSlice";
import DeleteBanner from "../banners/crudOperations/deleteBanner";
import { consoleLog } from "../../utils/log-utils";
import RadioItem from "./radio-item";
import AddRadio from "./add-radio";
import { changeStatus } from "../../redux/slice/loaderSlice";

function Radio() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [radioList, setRadioList] = useState([]);
  const [deleteBanner, setDeleteBanner] = useState(false);
  const showDeleteAlert = useSelector(deleteStatus);
  const showRequestForm = useSelector(formUpdateStatus);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    RadioApi();
  }, []);

  const RadioApi = async () => {
    setLoading(true);
    const data = await axios.get(
      API_CONFIG.API_HOST + RADIO_API_PATH.RADIO_LIST,
      {
        headers: API_HEADERS,
      }
    );
   
    consoleLog("radio  data",data.data.result)
    setLoading(false);
    if (data.data.result != null) setRadioList(data.data.result);
  };
 
  const onSubmit = () => {
    dispatch(changeStatus(false));
    dispatch(updateFormInfo({ displayForm: false, formData: {} }));
    dispatch(
      updateMessage({
        display: true,
        message: "Record updated",
      })
    );
    

    RadioApi();
  };

  
  consoleLog("delete banner",deleteBanner)

  return (
    <>

     {showRequestForm && (
        <AddRadio
          onSubmit={() => {
            onSubmit();
          }}
        />
      )}
      {showDeleteAlert && (
        <DeleteBanner
          onSubmit={() => {
            onSubmit();
          }}
        />
      )}
      <main className="container-fluid dashboard">
        <div className="row m-3">
          <div className="row justify-content-around tble">
            <div className="col-6">
              <h3 className="dashboard-title">Radio</h3>
            </div>
            <div className="mr-auto col-6 text-end">
              <button
                type="button"
                className="mr-auto btn add-button-color"
                onClick={() => {
                  dispatch(
                    updateFormInfo({
                      displayForm: true,
                      formData: {},
                    })
                  );
                }}
              >
                Add Radio
              </button>
            </div>
          </div>
        </div>
        <div className="row m-3">
          <div className="col-md-12 card-1 h-scroll">
            <table className="table table-hover align-middle">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Sno</th>
                  <th scope="col">Language</th>
                  <th scope="col">Image</th>
                  <th scope="col">Radio Url</th>
                  <th scope="col">Actions</th>
                  
                  
                 
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <>Loading ..</>
                ) : radioList && radioList.length > 0 ? (
                  <>
                    {radioList.map((item, index) => {
                      return (
                        <RadioItem
                          result={item}
                          key={item.id}
                          id={index + 1}
                        />
                      );
                    })}
                  </>
                ) : (
                  <> No Data</>
                )}
              </tbody>
            </table>
           {consoleLog("delete banner",deleteBanner)}


          </div>
        </div>
      </main>
    </>
  );
}

export default Radio;
